"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetProductSizeDetails = void 0;
const Base_1 = require("./Base");
exports.GetProductSizeDetails = {
    url: Base_1.URL_BASE + "/GetProductSizeDetails",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetProductSizeDetails.js.map